import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboardIcon, BarChart2Icon, BellIcon, SettingsIcon, FileTextIcon, UsersIcon, ClockIcon } from 'lucide-react';
const Sidebar: React.FC = () => {
  const {
    isAdmin
  } = useAuth();
  return <div className="bg-blue-800 text-white w-64 flex-shrink-0 hidden md:block" data-id="element-421">
      <div className="p-4 border-b border-blue-700" data-id="element-422">
        <h2 className="text-2xl font-bold" data-id="element-423">Energy Monitor</h2>
      </div>
      <nav className="mt-4" data-id="element-424">
        <ul className="space-y-1" data-id="element-425">
          <li data-id="element-426">
            <NavLink to="/dashboard" end className={({
            isActive
          }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-427">
              <LayoutDashboardIcon className="h-5 w-5 mr-3" data-id="element-428" />
              <span data-id="element-429">Dashboard</span>
            </NavLink>
          </li>
          <li data-id="element-430">
            <NavLink to="/dashboard/analytics" className={({
            isActive
          }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-431">
              <BarChart2Icon className="h-5 w-5 mr-3" data-id="element-432" />
              <span data-id="element-433">Analytics</span>
            </NavLink>
          </li>
          <li data-id="element-434">
            <NavLink to="/dashboard/notifications" className={({
            isActive
          }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-435">
              <BellIcon className="h-5 w-5 mr-3" data-id="element-436" />
              <span data-id="element-437">Notifications</span>
            </NavLink>
          </li>
          <li data-id="element-438">
            <NavLink to="/dashboard/history" className={({
            isActive
          }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-439">
              <ClockIcon className="h-5 w-5 mr-3" data-id="element-440" />
              <span data-id="element-441">Historical Data</span>
            </NavLink>
          </li>
          <li data-id="element-442">
            <NavLink to="/dashboard/export" className={({
            isActive
          }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-443">
              <FileTextIcon className="h-5 w-5 mr-3" data-id="element-444" />
              <span data-id="element-445">Export Data</span>
            </NavLink>
          </li>
          {isAdmin && <>
              <li className="px-4 pt-4 pb-2 text-xs text-blue-300 uppercase" data-id="element-446">
                Admin Controls
              </li>
              <li data-id="element-447">
                <NavLink to="/dashboard/settings" className={({
              isActive
            }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-448">
                  <SettingsIcon className="h-5 w-5 mr-3" data-id="element-449" />
                  <span data-id="element-450">Settings</span>
                </NavLink>
              </li>
              <li data-id="element-451">
                <NavLink to="/dashboard/users" className={({
              isActive
            }) => `flex items-center px-4 py-3 hover:bg-blue-700 ${isActive ? 'bg-blue-700' : ''}`} data-id="element-452">
                  <UsersIcon className="h-5 w-5 mr-3" data-id="element-453" />
                  <span data-id="element-454">User Management</span>
                </NavLink>
              </li>
            </>}
        </ul>
      </nav>
    </div>;
};
export default Sidebar;